var scrollPosition = 0;
jQuery(function ($) {
  "use strict";
  $(document).ready(function () {
    // Product Quick View
    $(document).on("click", ".ss-product-quick-view", function (event) {
      event.preventDefault();
      quickViewCallback(`/products/${$(this).data("handle")}`);
    });

    // Product Quick View Color Swatch
    $(document).on(
      "click",
      ".ss-product-quick-view-content a.color_swatch",
      function (event) {
        event.preventDefault();
        if ($(this).hasClass("active")) return;
        $(document).find(".ss-product-quick-view-content").html("");
        quickViewCallback($(this).attr("href"));
      }
    );

    $(document).on(
      "click",
      ".ss-product-quick-view-content > span.ss-close-view",
      function (event) {
        event.preventDefault();

        $(document).find(".ss-product-quick-view-content").html("");
        $(document)
          .find(".ss-product-quick-view-content")
          .removeClass("active");

        setTimeout(function () {
          $(document)
            .find("#ss-product-quick-view-container")
            .removeClass("active");
          // $(document).find("body").removeClass("overflow-hidden");
          $(document).find("body").css("overflow", "visible");
        }, 150);
      }
    );
  });

  function quickViewCallback(handle) {
    $(document).find("#ss-product-quick-view-container").addClass("active");
    setTimeout(function () {
      $(document).find(".ss-product-quick-view-content").addClass("active");
    }, 50);
    // $("body").addClass("overflow-hidden");
    $(document).find("body").css("overflow", "hidden");

    const request = new XMLHttpRequest();
    request.addEventListener("load", function () {
      const responseHTML = new DOMParser().parseFromString(
        this.responseText,
        "text/html"
      );
      const productElement = responseHTML.querySelector(
        'section[id^="MainProduct-"]'
      );

      const sectionId = productElement.dataset.section;
      productElement.innerHTML = productElement.innerHTML.replaceAll(
        sectionId,
        `quickadd-${sectionId}`
      );
      productElement
        .querySelectorAll("variant-selects, variant-radios")
        .forEach((variantSelect) => {
          variantSelect.dataset.originalSection = sectionId;
        });

      setInnerHTML(
        document.querySelector(".ss-product-quick-view-content"),
        productElement.innerHTML
      );

      // $(document).find(".ss-product-quick-view-content").addClass("active");

      // gallerySliderQuickView();

      document
        .querySelector(".ss-product-quick-view-content > .product")
        .addEventListener("scroll", function () {
          if (document.querySelector(".ss-product-info-wrapper") != null) {
            requestAnimationFrame(function () {
              calcPlacement();
            });
          }
        });

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      document
        .querySelector(".ss-product-quick-view-content")
        .querySelector("variant-radios,variant-selects")
        .setAttribute("data-update-url", "false");

      document
        .querySelector(".ss-product-quick-view-content")
        .querySelectorAll(".accordion details")
        .forEach((el) => {
          new Accordion(el);
        });

      document
        .querySelector(".ss-product-quick-view-content")
        .querySelectorAll(".color_swatch")
        .forEach(function (obj) {
          obj.onmouseover = function () {
            var color = obj.getAttribute("data-value");
            document
              .querySelector(".ss-product-quick-view-content")
              .querySelectorAll(".current_color")
              .forEach(function (obj1) {
                obj1.textContent = color;
              });
          };

          obj.onmouseout = function () {
            document
              .querySelector(".ss-product-quick-view-content")
              .querySelectorAll(".current_color")
              .forEach(function (obj1) {
                obj1.textContent = obj1.getAttribute("data-value");
              });
          };
        });
    });
    request.open("GET", handle + "/?section_id=main-product-quick-view", true);
    request.send();

    return;
  }

  function setInnerHTML(element, html) {
    const closeIcon =
      '<span class="ss-close-view"><svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" fill="#000000" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"></rect><line x1="200" y1="56" x2="56" y2="200" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="24" fill="none"></line><line x1="200" y1="200" x2="56" y2="56" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="24" fill="none"></line></svg></span>';
    element.innerHTML = closeIcon + html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }

  function calcPlacement() {
    const windowWrapper = document.querySelector(
      ".ss-product-quick-view-content > .product"
    );
    const windowHeight = windowWrapper.clientHeight;

    const componentWrapper = document.querySelector(".ss-product-info-wrapper");
    const componentHeight = componentWrapper.clientHeight;

    const navAndBreadcrumbsHeight = 0;

    const scrollYPosition =
      windowWrapper.scrollTop - componentWrapper.scrollTop;
    const isScrollingDown = scrollYPosition >= scrollPosition;

    const componentBoundingRect = componentWrapper.getBoundingClientRect(); // Component
    const containerBoundingRect = document
      .querySelector(".product__info-wrapper")
      .getBoundingClientRect(); // Container

    if (componentHeight <= windowHeight - navAndBreadcrumbsHeight) {
      setPosition("sticky", navAndBreadcrumbsHeight);
    } else if (
      isScrollingDown &&
      Math.abs(componentBoundingRect.top - navAndBreadcrumbsHeight) >=
        Math.max(componentHeight - windowHeight + navAndBreadcrumbsHeight, 0)
    ) {
      setPosition("sticky", windowHeight - componentHeight);
    } else if (
      !isScrollingDown &&
      componentBoundingRect.top >= navAndBreadcrumbsHeight
    ) {
      setPosition("sticky", navAndBreadcrumbsHeight);
    } else {
      setPosition(
        "relative",
        -1 * containerBoundingRect.y + componentBoundingRect.top
      );
    }

    scrollPosition = Math.max(scrollYPosition, 0);
  }

  function gallerySliderQuickView() {
    $(".slick-slider-container").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
    });
  }
});
